export default __webpack_public_path__ + "static/RobertSkinner-5944c46c88d167a0815a0678bd3280a7.jpg";